import { CLEAR_RELEASE } from '../../actionTypes';

export default () => (dispatch) => dispatch({ type: CLEAR_RELEASE });
